export enum COMPONENT_TYPES {
  ANSWER_DISPLAY_ELEMENT = 'AnswerDisplayElement',
  TEXTAREA_FIELD = 'TextAreaElement',
  TEXT_FIELD_ELEMENT = 'TextFieldElement',
  RATING_5_STARS_ELEMENT = 'Rating5StarsElement',
  BUTTON = 'ButtonElement',
  TEXT_ELEMENT = 'TextElement',
  SELECT_FACILITY_ELEMENT = 'SelectFacilityElement',
  HEADING_TEXT_ELEMENT = 'HeadingTextElement',
  IMAGE_ELEMENT = 'ImageElement',
  LINK_ELEMENT = 'LinkElement',
  SINGLE_SELECT_ELEMENT = 'SingleSelectElement',
  AI_GENERATED_TEXT_AREA_ELEMENT = 'AIGeneratedTextAreaElement',
  GROUPING_ELEMENT = 'GroupingElement',
  CHECKBOX_ELEMENT = 'CheckboxElement',
  MULTIPLE_SELECT_ELEMENT = 'MultipleSelectElement',
  SOCIAL_MEDIA_SHARE_ELEMENT = 'SocialMediaShareElement',
  SINGLE_BUTTON_SELECT_ELEMENT = 'SingleButtonSelectElement',
}
